module.exports = __webpack_public_path__ + "assets/img/portfolio-big-10.4351507e.png";